import React from "react";
import FeedbackEmotionCard from "./FeedbackEmotionCard";
import styles from "./FeedbackEmotionRatingListing.module.scss";

const FeedbackEmotionRatingListing = ({
  inputID,
  emotionRatingList,
  updateEmotionRatingFormData,
}) => {
  return (
    <div className={styles.container}>
      {emotionRatingList &&
        emotionRatingList.length > 0 &&
        emotionRatingList.map(item => (
          <FeedbackEmotionCard
            key={`${item.rating}-${item.description}`}
            inputID={inputID}
            emotionRating={item}
            emotionRatingList={emotionRatingList}
            updateEmotionRatingFormData={updateEmotionRatingFormData}
          />
        ))}
    </div>
  );
};

export default FeedbackEmotionRatingListing;
